<!-- <p-popover #op appendTo="body">
    {{ process?.ProcessDesc }}
</p-popover>

<div class="grid">
    <div class="col col-6 pb-0 mb-0">
        <h2 #processTitle class="mt-2 mb-1">
            <label class="ml-4 mr-1 font-medium">{{ process?.ProcessTitle }}</label>
            <i class="pi pi-info-circle text-primary" href="javascript:;" (click)="op.show($event)" style="cursor: help; font-size: 14px; font-weight: 600;"></i>
        </h2>
    </div>
    <div class="col col-6">
        <div
            style="
                display: flex;
                flex-direction: row;
                align-items: center;
                flex-wrap: wrap;
                top: 1;
                position: absolute;
                right: 0;
                padding-top: 0.4em;
            "
        >
            <a
                id="lnk-demo"
                #demo
                class="text-primary"
                *ngIf="process?.UrlDemo"
                [href]="process?.UrlDemo"
                target="_blank"
                data-toggle="tooltip"
                data-placement="top"
                title="Short Introduction"
                trigger="hover"
                style="padding-right: 2.5em;"
            >
                <div style="padding: 0; margin-bottom: -0.3em">
                    <i
                        class="pi pi-video"
                        style="font-size: 1.75em; padding: 0"
                    ></i>
                </div>
                <span
                    class="topbar-item-name"
                    style="font-weight: 500; font-size: 10.5px"
                    >Video</span
                >
            </a>
            <a
                id="lnk-help"
                #documentation
                class="text-primary"
                *ngIf="process?.UrlDocumentation"
                [href]="process?.UrlDocumentation"
                target="_blank"
                data-toggle="tooltip"
                data-placement="top"
                title="Documentation"
                trigger="hover"
                style="padding-right: 2.5em"
            >
                <div style="padding: 0; margin-bottom: -0.3em">
                    <i
                        class="pi pi-book"
                        style="
                            font-size: 1.75em;
                            padding: 0;
                            transform: rotate(20deg);
                        "
                    ></i>
                </div>
                <span
                    class="topbar-item-name"
                    style="font-weight: 500; font-size: 10.5px"
                    >Help</span
                >
            </a>
        </div>
    </div>
</div> -->
